import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isCollapsed = true, onToggle = () => {} }) => {
  const location = useLocation();
  const { currentUser, logout } = useContext(AuthContext);
  
  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  // Obtener la primera letra del nombre para el avatar
  const getInitial = () => {
    if (currentUser?.nombre) {
      return currentUser.nombre.charAt(0);
    }
    return currentUser?.rol === 'ADMIN' ? 'A' : 'D';
  };
  
  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : 'expanded'}`}>
      <div className="sidebar-header">
        <button type="button" className="sidebar-collapse-button" onClick={onToggle}>
          <i className={`fas ${isCollapsed ? 'fa-angle-right' : 'fa-angle-left'}`}></i>
        </button>

        {!isCollapsed ? (
          <>
            <h2>Panel {currentUser?.rol === 'ADMIN' ? 'Admin' : 'Doctor'}</h2>
            <p className="sidebar-subheader">Sistema de Citas</p>
          </>
        ) : null}
      </div>
      
      <div className="sidebar-menu">
        <Link 
          to="/dashboard" 
          className={`sidebar-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
          title="Dashboard"
        >
          <i className="fas fa-tachometer-alt sidebar-icon"></i>
          {!isCollapsed ? 'Dashboard' : null}
        </Link>
        
        <Link 
          to="/dashboard/citas-doctor" 
          className={`sidebar-item ${isActive('/dashboard/citas-doctor') ? 'active' : ''}`}
          title="Citas del Doctor"
        >
          <i className="fas fa-user-md sidebar-icon"></i>
          {!isCollapsed ? 'Citas del Doctor' : null}
        </Link>

        <Link 
          to="/dashboard/pacientes" 
          className={`sidebar-item ${isActive('/dashboard/pacientes') || isActive('/dashboard/historia-clinica') ? 'active' : ''}`}
          title="Pacientes e Historias"
        >
          <i className="fas fa-users sidebar-icon"></i>
          {!isCollapsed ? 'Pacientes e Historias' : null}
        </Link>

        {/* <Link 
          to="/dashboard/plantillas" 
          className={`sidebar-item ${isActive('/dashboard/plantillas') ? 'active' : ''}`}
        >
          <i className="fas fa-clipboard-list sidebar-icon"></i>
          Plantillas
        </Link>

        <Link 
          to="/dashboard/configuracion" 
          className={`sidebar-item ${isActive('/dashboard/configuracion') ? 'active' : ''}`}
        >
          <i className="fas fa-cog sidebar-icon"></i>
          Configuración
        </Link>
        
        <Link 
          to="/dashboard/test-receta" 
          className={`sidebar-item ${isActive('/dashboard/test-receta') ? 'active' : ''}`}
        >
          <i className="fas fa-vial sidebar-icon"></i>
          Test Recetas PDF
        </Link> */}
      </div>
      
      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {getInitial()}
          </div>
          {!isCollapsed ? (
            <div className="user-details">
              <div className="user-name">
                {currentUser?.nombre} {currentUser?.apellido || ''}
              </div>
              <div className="user-role">
                {currentUser?.rol === 'ADMIN' ? 'Administrador' : currentUser?.doctor?.especialidad || 'Médico'}
              </div>
            </div>
          ) : null}
        </div>
        
        <button onClick={logout} className="logout-button" title="Cerrar Sesión">
          <i className="fas fa-sign-out-alt sidebar-icon"></i>
          {!isCollapsed ? 'Cerrar Sesión' : null}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;